import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubspotFormBoxComponent } from './hubspot-form-box.component';
import { HubspotModule } from '../hubspot/hubspot.module';
import { DaButtonModule } from '../da-button/da-button.module';

@NgModule({
    declarations: [HubspotFormBoxComponent],
    imports: [CommonModule, HubspotModule, DaButtonModule],
    exports: [HubspotFormBoxComponent]
})
export class HubspotFormBoxModule {}
